import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiAkgDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiAkgDetay';
import rList from '../../../../api/models/rList';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIAKGDETAY,
    new Api.Bilgi.OyakKiraBilgileriUstBilgiAkgDetay().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rOyakKiraBilgileriUstBilgiAkgDetay> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakKiraBilgileriUstBilgiAkgDetay[]> =>
  ActionFunctions.action_async_complete_api<rOyakKiraBilgileriUstBilgiAkgDetay[]>(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIAKGDETAY,
    data?.Values,
    error
  );
